var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path7, _polygon, _path8, _polygon2, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b0c2ce5f-88b4-49a2-9766-ff0a73ff0798",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 971.55619,
    height: 781.4172,
    viewBox: "0 0 971.55619 781.4172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1078.5806,512.254H336.75838a7.20537,7.20537,0,0,1-7.1975-7.1975V66.4889a7.20537,7.20537,0,0,1,7.1975-7.1975H1078.5806a7.20536,7.20536,0,0,1,7.19749,7.1975V505.05649A7.20536,7.20536,0,0,1,1078.5806,512.254ZM336.75838,62.1704a4.32322,4.32322,0,0,0-4.3185,4.3185V505.05649a4.32322,4.32322,0,0,0,4.3185,4.3185H1078.5806a4.32321,4.32321,0,0,0,4.31849-4.3185V66.4889a4.32321,4.32321,0,0,0-4.31849-4.3185Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bbcc4262-a9b8-4c1e-bf70-e1245b5187b9",
    "data-name": "a332a05d-d774-4fd2-8531-ab97682a63e9",
    d: "M636.16347,94.31766a5.707,5.707,0,0,0,0,11.4124H779.236a5.707,5.707,0,0,0,.20407-11.41212l-.01669-.00028q-.09366-.0016-.18738,0Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M811.68137,92.72878a1.12288,1.12288,0,0,0-.00012,1.5879l.00012.00009,4.82024,4.82028H804.61537a1.12287,1.12287,0,0,0,0,2.24573h11.88624l-4.82024,4.82029a1.12285,1.12285,0,0,0,1.58793,1.588h0l6.73717-6.73714a1.12294,1.12294,0,0,0,0-1.588l-6.73717-6.73714a1.12278,1.12278,0,0,0-1.58787,0Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M603.6576,92.72878a1.12283,1.12283,0,0,1,.00009,1.5879l-.00009.00009-4.82023,4.82028h11.88624a1.12287,1.12287,0,1,1,.00266,2.24573h-11.8889l4.82023,4.82029a1.12286,1.12286,0,1,1-1.58795,1.588h0l-6.73714-6.73714a1.12294,1.12294,0,0,1,0-1.588l6.73714-6.73714a1.12284,1.12284,0,0,1,1.5879-.00006Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M329.13147,536.41184a32.89015,32.89015,0,1,1,32.89016-32.89015A32.89017,32.89017,0,0,1,329.13147,536.41184Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#fd9926"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M342.10905,500.27734h-9.73313v-9.73326a3.24445,3.24445,0,1,0-6.4889,0v9.73326h-9.73326a3.2444,3.2444,0,1,0,0,6.4888H325.887v9.73325a3.24445,3.24445,0,0,0,6.4889,0v-9.73325h9.73313a3.2444,3.2444,0,1,0,0-6.4888Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 275.31813,
    y: 93.44997,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 409.67144,
    y: 93.44997,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 544.02476,
    y: 93.44997,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 678.37807,
    y: 93.44997,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 812.73138,
    y: 93.44997,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 275.68058,
    y: 211.48895,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 410.03389,
    y: 211.48895,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 544.38721,
    y: 211.48895,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 678.74052,
    y: 211.48895,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 813.09383,
    y: 211.48895,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 276.04303,
    y: 329.52793,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 410.39634,
    y: 329.52793,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 544.74966,
    y: 329.52793,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 679.10297,
    y: 329.52793,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 813.45628,
    y: 329.52793,
    width: 98.84565,
    height: 67.17666,
    fill: "#f1f1f1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 564.5402,
    cy: 114.56263,
    r: 12.47566,
    fill: "#fd9926"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 428.26756,
    cy: 232.60161,
    r: 12.47566,
    fill: "#fd9926"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 564.5402,
    cy: 350.64059,
    r: 12.47566,
    fill: "#fd9926"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 701.77251,
    cy: 232.60161,
    r: 12.47566,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.16616,
    cy: 232.60161,
    r: 12.47566,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 428.26756,
    cy: 350.64059,
    r: 12.47566,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.16464,
    cy: 446.62674,
    r: 23.17166,
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M207.02049,643.02907q-.43776,0-.87939-.0387a10.38028,10.38028,0,0,1-9.31638-12.37427,9.71913,9.71913,0,0,1,.25473-.98672L162.88,589.18159a8.06132,8.06132,0,0,1-.56085-9.60846l.062-.07556,30.78363-30.35382a8.89853,8.89853,0,0,1,12.49527,12.67294q-.05792.05714-.11689.11316l-22.2955,21.1959,24.40808,39.17453a9.87852,9.87852,0,0,1,1.37668.16952,10.38,10.38,0,0,1-2.01193,20.55927Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "139.328 769.118 150.895 769.118 156.397 724.505 139.326 724.506 139.328 769.118",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250.60008,824.63365l22.778-.00092h.00092A14.51569,14.51569,0,0,1,287.89512,839.148v.47235l-37.29437.00141Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "24.366 753.127 34.304 759.044 61.857 723.527 47.189 714.794 24.366 753.127",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.98481,807.66411,157.55647,819.317l.00079.00049a14.51572,14.51572,0,0,1,5.04612,19.89844l-.00031.00048-.24133.40534L130.31726,820.5424Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M267.84584,812.65245H254.89415a4.23771,4.23771,0,0,1-4.2215-3.79675L237.61546,686.11827a1.41542,1.41542,0,0,0-2.69717-.433L211.3629,737.844l-41.70359,68.00268a4.26565,4.26565,0,0,1-5.32891,1.66577l-16.66025-7.33a4.24676,4.24676,0,0,1-1.93479-6.06415l38.33707-64.19208,11.75766-54.0852c-3.69794-23.455,12.155-58.326,12.31577-58.67615l.07855-.17044,43.66751-17.06766.219.2681C269.33214,656.7086,279.826,717.527,272.07768,808.76262A4.27414,4.27414,0,0,1,267.84584,812.65245Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M206.46516,622.70933l-.20337-.42749c-.0972-.20453-9.807-20.68365-17.292-42.57147a32.285,32.285,0,0,1,2.23859-25.87344A32.63729,32.63729,0,0,1,212.021,537.83265h0a32.677,32.677,0,0,1,37.92776,19.56977c5.93723,14.84707,4.045,30.69452,2.26429,43.15722l-.03547.2497-.22711.1087Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#fd9926"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M243.48152,492.82893H206.68767V476.7906c8.07583-3.20837,15.97845-5.93692,20.75552,0a16.03847,16.03847,0,0,1,16.03836,16.03833Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M204.65062,473.96031c-21.99607,0-28.1528,27.5712-28.1528,43.12552,0,8.67447,3.923,11.777,10.08755,12.82681l2.17709-11.611,5.099,12.11063c1.73163.00863,3.55078-.02488,5.43671-.05988l1.72885-3.55988,3.85526,3.496c15.44085.023,27.92062,2.27383,27.92062-13.2027C232.8029,501.53151,227.40355,473.96031,204.65062,473.96031Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M302.42137,504.81776q.20983.38416.38766.79032a10.38032,10.38032,0,0,1-6.3927,14.10855,9.72348,9.72348,0,0,1-.98806.24951L276.32884,569.371a8.06133,8.06133,0,0,1-8.16324,5.09885l-.096-.01816L226.673,561.98955a8.89852,8.89852,0,0,1,5.1315-17.0412q.07744.02334.15451.04806l29.29034,9.40381,22.67642-40.20175a9.87567,9.87567,0,0,1-.51126-1.28943,10.38005,10.38005,0,0,1,19.0069-8.09131Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#ffb8b8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M307.22191,840.7086h-192a1,1,0,1,1,0-2h192a1,1,0,1,1,0,2Z",
    transform: "translate(-114.22191 -59.2914)",
    fill: "#ccc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventSuccess);
export default __webpack_public_path__ + "static/media/event-success.5b4a8876f69eedf0d58c5b9342741942.svg";
export { ForwardRef as ReactComponent };